import * as React from "react";
import { cn } from "@/utils/cn";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    loading?: boolean;
}

function Skeleton({
    className,
    loading = true,
    children,
    ...props
}: SkeletonProps) {
    if (!loading) return <>{children}</>;

    return (
        <div
            className={cn("animate-pulse rounded-md bg-gray-200 dark:bg-gray-700", className)}
            {...props}
        />
    );
}

export { Skeleton };
export default Skeleton;
